import { Flavour } from '@/enums/flavours'
import { Language } from '@/enums/language'

export const languageByFlavour = {
  [Flavour.TFW]: [Language.EN, Language.CY],
}
